import { createContext } from 'react';

/**
 * Lets a {@link DropdownItem} close the {@link DropdownMenu} it was rendered
 * in without the menu having to clone its children.
 */
export default createContext({
    close: () => {
        // No-op default, replaced by the provider.
    }
});
